<template>
<li>
  <div :class="{bold: isFolder, root: !model.id}">

    <a href="#" @click.prevent="selectItem(model)" :class="{name: true, active: isSelected(model)}">{{model.name}}</a>
    <span v-if="isFolder" @click="toggle">
      <a class="open-link" v-if="open"> - </a>
      <a class="open-link" v-if="!open"> + </a>
    </span>
  </div>
  <ul v-show="open" v-if="isFolder">
    <tree class="item" v-for="model, index in model.children" :key="index" :model="model" :selected="selected"></tree>
  </ul>
</li>
</template>
<script>
export default {
  name: 'tree',
  props: {
    model: Object,
    selected: Object
  },
  data: function () {
    return {
      open: true
    }
  },
  computed: {
    isFolder: function () {
      return this.model.children &&
        this.model.children.length
    }
  },
  methods: {
    toggle () {
      if (this.isFolder) {
        this.open = !this.open
      }
    },
    isSelected (model) {
      if (!model || !this.selected || model.isRoot) {
        return false
      }
      return this.selected.id === model.id ? 'active' : ''
    },
    changeType () {
      if (!this.isFolder) {
        // TODO sprawdzić czy to będzie działać Vue.set(this.model, 'children', [])
        this.addChild()
        this.open = true
      }
    },
    selectItem (model) {
      if (model.id) {
        this.$dispatch('tree.selected', model)
      }
    },
    addChild () {
      this.model.children.push({
        name: 'new stuff'
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// Tree.vue?f5474bba